export default "__VITE_ASSET__CFKewNaP__"